export default (priceWithoutTax, salesTax) => {
    return priceWithoutTax * (1 + Number(salesTax));
}